import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
var FeatureFlagContext = createContext(null);
export var FeatureFlagProvider = function (_a) {
    var flags = _a.flags, children = _a.children;
    return _jsx(FeatureFlagContext.Provider, { value: flags, children: children });
};
// Internal — only consumed by useFeatureFlag. Call that hook instead of this directly.
export var useFeatureFlagContext = function () { return useContext(FeatureFlagContext); };
